import React from "react";

const ReportViewerMockPage = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Report Viewer Mock</h1>
      <p>This route is under construction.</p>
    </div>
  );
};

export default ReportViewerMockPage;
